import * as professionalsTokens from '../generated/pillar/professionals/tokens';
import getChakraThemeFromTokens from '../getChakraThemeFromTokens';

const professionalsTheme = getChakraThemeFromTokens(professionalsTokens);

export default professionalsTheme;
